import React from "react";
import styles from "./Announcement.module.css";
import Marquee from "react-fast-marquee";

const Announcement = () => {
    return (
        <div className={styles.announcement}>
            <div className={styles.container}>
                <h4>Beneficios:</h4>
                <Marquee className={styles.marquee} gradient={false} speed={50} autoFill={true}>
                    <span className={styles.marqueeItem}>6 Meses al 30%</span>
                    <span className={styles.marqueeItem}>-</span>
                    <span className={styles.marqueeItem}>Pack con Cámara</span>
                    <span className={styles.marqueeItem}>-</span>
                    <span className={styles.marqueeItem}>Instalación Rápida</span>
                    <span className={styles.marqueeItem}>-</span>
                    <span className={styles.marqueeItem}>Últimos Días</span>
                    <span className={styles.marqueeItem}>-</span>
                </Marquee>
            </div>
        </div>
    );
};

export default Announcement;
